import { Injectable } from '@angular/core'
import { EntitySignalStore } from '@awork/core/state/signal-store/entitySignalStore'
import { ProjectType } from '@awork/features/project/models/project-type.model'

@Injectable({ providedIn: 'root' })
export class ProjectTypeStore extends EntitySignalStore<ProjectType> {
  constructor() {
    super({ name: 'projectType', entityConstructor: projectType => new ProjectType(projectType) })
  }
}
